import '../../styles/App.css';

export default function MiniAnalytics() {
        return (
            <>
                <div id="minianalytics-block">
                    Few 'Fun Facts' from the overall Analytics data set.
                </div>
            </>
        )
}